export const amountContainerInfo = {
  winContainer: 'isWinContainer',
  lastWinContainer: 'isLastWinContainer',
  totalWinContainer: 'isTotalWinContainer',
};
